import { render, staticRenderFns } from "./FamilyPatientsProfile.vue?vue&type=template&id=4aeb0111&scoped=true"
import script from "./FamilyPatientsProfile.vue?vue&type=script&lang=js"
export * from "./FamilyPatientsProfile.vue?vue&type=script&lang=js"
import style0 from "./FamilyPatientsProfile.vue?vue&type=style&index=0&id=4aeb0111&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeb0111",
  null
  
)

export default component.exports